// Envio de eventos para o dataLayer (o GTM decide o que repassa ao GA4).
//
// Regra: NUNCA enviar dado pessoal (nome, e-mail, telefone, endereço, texto livre
// digitado pelo cliente). Campos de texto livre passam por sanitize* antes.

// Todas as chaves de parâmetro usadas em qualquer evento. Vão zeradas em todo push
// para o GTM não reaproveitar o valor do evento anterior (o dataLayer é "merge").
// Mantenha em sincronia com djparafestas-web/src/utils/track.js.
const CHAVES_ZERADAS = {
    page_location: undefined,
    page_title: undefined,
    tipo_pagina: undefined,
    origem_componente: undefined,
    lead_tipo: undefined,
    tipo_evento: undefined,
    cidade: undefined,
    perfil_slug: undefined,
    local_clique: undefined,
    rede: undefined,
    method: undefined,
    transaction_id: undefined,
    value: undefined,
    currency: undefined,
    origem_contato: undefined,
};

const isPrerender = () =>
    typeof navigator !== 'undefined' && /ReactSnap/i.test(navigator.userAgent);

export function track(event, params = {}) {
    if (typeof window === 'undefined' || isPrerender()) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...CHAVES_ZERADAS, ...params });
}

// Categoria fixa a partir do "Tipo de Evento" digitado — evita mandar texto livre
// (ex.: "Casamento da Maria") para o GA.
const TIPOS_EVENTO = [
    ['casamento', /casament|noiv|boda/],
    ['15_anos', /15|quinze|debutante/],
    ['formatura', /formatura|colacao/],
    ['corporativo', /corporativ|empresa|confraterniza/],
    ['infantil', /infantil|crianca|kids/],
    ['aniversario', /aniversari|niver/],
    ['bar_balada', /\bbar\b|balada|boate|pub/],
];

const semAcento = (s) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

export function sanitizeTipoEvento(raw) {
    if (!raw) return undefined;
    const t = semAcento(String(raw));
    const found = TIPOS_EVENTO.find(([, re]) => re.test(t));
    return found ? found[0] : 'outro';
}

// Cidade vinda de texto livre: pega só o 1º trecho ("Contagem - Eldorado" → "contagem")
// e descarta se parecer endereço (tem número ou @).
export function sanitizeCidade(raw) {
    if (!raw) return undefined;
    const first = String(raw).split(/[,/\-–]/)[0].trim();
    if (!first || first.length > 40 || /[\d@]/.test(first)) return undefined;
    return semAcento(first);
}

// page_location sem query string em /track-order/* (a query carrega a assinatura do link).
export function pageLocation(loc = window.location) {
    if (loc.pathname.startsWith('/track-order/')) return loc.origin + loc.pathname;
    return loc.href;
}

export function tipoPaginaSite(pathname) {
    if (pathname === '/') return 'home';
    if (pathname.startsWith('/djs/')) return 'cidade';
    if (pathname.startsWith('/perfil/')) return 'perfil';
    if (pathname.startsWith('/artistas')) return 'artistas';
    if (/^\/(track-order|proposta|leads)\//.test(pathname)) return 'pedido';
    return 'institucional';
}
